// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function (event) {

  // --- scrollEffect ---
  if (document.querySelector('.js-slideup')) {
    document.querySelectorAll('.js-slideup').forEach(elm => {

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function () {
          elm.classList.remove('init');
        },
        onLeaveBack: function () {
          elm.classList.add('init');
        },
      });
    });
  }

  // --- about animation ---
  if (document.querySelector('.js-about')) {
    document.querySelectorAll('.js-about').forEach(section => {

      const items = section.querySelectorAll('.js-about-item');

      gsap.set(items, {
        y: 20,
        opacity: 0
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 60%',
          toggleActions: 'play none none reverse',
        }
      });

      tl.to(items, {
        y: 0,
        opacity: 1,
        duration: 2,
        ease: 'power3.out',
        stagger: 0.3,
      });

    });
  }

});

